import styled, { createGlobalStyle } from 'styled-components'
import { cardisTheme } from '../../theme/cardisTheme'

export const PrintStyles = createGlobalStyle``

export const Container = styled.div`
  width: 100%;
  padding: 0mm ${cardisTheme.spacing.pageMargin};
  display: flex;
  flex-direction: column;
  gap: ${cardisTheme.spacing.smallGap};
  background: ${cardisTheme.colors.background};

  @media print {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    gap: 0;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: ${cardisTheme.spacing.contentGap};
  padding-bottom: ${cardisTheme.spacing.tinyGap};
  margin-bottom: ${cardisTheme.spacing.contentGap};
  border-bottom: 2px solid ${cardisTheme.colors.primary};
`

export const Logo = styled.img`
  max-width: 144px;
  height: auto;
  object-fit: contain;
  padding-bottom: ${cardisTheme.spacing.smallGap};

  @media print {
    min-height: 0px !important;
    padding-bottom: ${cardisTheme.spacing.sectionGap} !important;
  }
`

export const Title = styled.h1`
  font-family: ${cardisTheme.fonts.heading};
  font-size: ${cardisTheme.fontSizes.xlarge};
  font-weight: ${cardisTheme.fontWeights.bold};
  color: ${cardisTheme.colors.primary};
  text-align: center;
  margin: 0;
  @media print {
    font-size: ${cardisTheme.fontSizes.xlarge} !important;
    margin-bottom: ${cardisTheme.spacing.tinyGap} !important;
  }
`

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${cardisTheme.spacing.smallGap};

  @media print {
    page-break-inside: avoid;
    break-inside: avoid;
    margin-bottom: ${cardisTheme.spacing.smallGap};
    margin-top: ${cardisTheme.spacing.smallGap};
  }
`

export const SectionTitle = styled.h2`
  font-family: ${cardisTheme.fonts.heading};
  font-size: ${cardisTheme.fontSizes.large};
  font-weight: ${cardisTheme.fontWeights.semibold};
  color: ${cardisTheme.colors.primary};
  margin: 0;
  padding-bottom: ${cardisTheme.spacing.smallGap};
  border-bottom: 1px solid ${cardisTheme.colors.border};
  text-transform: uppercase;

  @media print {
    margin-bottom: ${cardisTheme.spacing.tinyGap} !important;
  }
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${cardisTheme.spacing.smallGap};
`

export const FieldColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${cardisTheme.spacing.smallGap};
  flex: 1;
`

export const FieldRow = styled.div`
  display: flex;
  gap: ${cardisTheme.spacing.contentGap};
  align-items: flex-start;

  @media print {
    page-break-inside: avoid;
  }
`

export const FieldLabel = styled.span`
  font-family: ${cardisTheme.fonts.body};
  font-size: ${cardisTheme.fontSizes.body};
  font-weight: ${cardisTheme.fontWeights.medium};
  color: ${cardisTheme.colors.textLight};
  min-width: 120px;
`

export const FieldValue = styled.span`
  font-family: ${cardisTheme.fonts.body};
  font-size: ${cardisTheme.fontSizes.body};
  color: ${cardisTheme.colors.text};
  flex: 1;
`

export const Text = styled.p`
  font-family: ${cardisTheme.fonts.body};
  font-size: ${cardisTheme.fontSizes.body};
  color: ${cardisTheme.colors.text};
  line-height: 1.4;
  margin: 0;
  text-align: justify;

  @media print {
    orphans: 3;
    widows: 3;
  }
`

export const FixedText = styled(Text)`
  font-weight: ${cardisTheme.fontWeights.normal};
  margin: 0 !important;
`

export const MandataireBox = styled.div`
  background: ${cardisTheme.colors.backgroundGray};
  border-left: 3px solid ${cardisTheme.colors.primary};
  padding: ${cardisTheme.spacing.smallGap} ${cardisTheme.spacing.contentGap};
  display: flex;
  flex-direction: column;
  margin-bottom: ${cardisTheme.spacing.smallGap};
`

export const SignatureSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${cardisTheme.spacing.sectionGap};
  margin-top: ${cardisTheme.spacing.sectionGap};

  @media print {
    page-break-inside: avoid;
  }
`

export const SignatureHeader = styled.div`
  display: flex;
  gap: ${cardisTheme.spacing.contentGap};
  align-items: center;
`

export const SignatureGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${cardisTheme.spacing.sectionGap};

  @media print {
    page-break-inside: avoid;
  }
`

export const SignatureColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${cardisTheme.spacing.contentGap};
`

export const SignatureColumnTitle = styled.h3`
  font-family: ${cardisTheme.fonts.heading};
  font-size: ${cardisTheme.fontSizes.medium};
  font-weight: ${cardisTheme.fontWeights.semibold};
  color: ${cardisTheme.colors.primary};
  margin: 0;
`

export const SignatureBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${cardisTheme.spacing.tinyGap};
`

export const SignatureLine = styled.div`
  border-bottom: 1px solid ${cardisTheme.colors.text};
  min-height: 48px;
  margin-top: ${cardisTheme.spacing.smallGap};
`

export const MandantsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${cardisTheme.spacing.contentGap};
`

export const PriceTable = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${cardisTheme.spacing.smallGap} 0;
`

export const PriceRow = styled.div<{ isTotal?: boolean }>`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: ${cardisTheme.spacing.contentGap};
  align-items: center;
  padding: 0;

  ${({ isTotal }) =>
    isTotal &&
    `
    padding-top: ${cardisTheme.spacing.contentGap};
    border-top: 2px solid ${cardisTheme.colors.primary};
    margin-top: ${cardisTheme.spacing.smallGap};
  `}
`

export const PriceLabel = styled.span<{ isTotal?: boolean }>`
  font-family: ${cardisTheme.fonts.body};
  font-size: ${({ isTotal }) =>
    isTotal ? cardisTheme.fontSizes.medium : cardisTheme.fontSizes.body};
  font-weight: ${({ isTotal }) =>
    isTotal
      ? cardisTheme.fontWeights.semibold
      : cardisTheme.fontWeights.normal};
  color: ${({ isTotal }) =>
    isTotal ? cardisTheme.colors.primary : cardisTheme.colors.text};
`

export const PriceValue = styled.span<{ isTotal?: boolean }>`
  font-family: ${cardisTheme.fonts.body};
  font-size: ${({ isTotal }) =>
    isTotal ? cardisTheme.fontSizes.medium : cardisTheme.fontSizes.body};
  font-weight: ${({ isTotal }) =>
    isTotal ? cardisTheme.fontWeights.bold : cardisTheme.fontWeights.normal};
  color: ${({ isTotal }) =>
    isTotal ? cardisTheme.colors.primary : cardisTheme.colors.text};
  text-align: right;
  min-width: 160px;
`

export const EditablePrice = styled.input`
  font-family: ${cardisTheme.fonts.body};
  font-size: ${cardisTheme.fontSizes.body};
  font-weight: ${cardisTheme.fontWeights.normal};
  color: ${cardisTheme.colors.text};
  min-width: 160px;
  text-align: right;
  border: none;
  border-bottom: 1px solid transparent;
  background: transparent;
  padding: ${cardisTheme.spacing.tinyGap} ${cardisTheme.spacing.smallGap};
  margin: 0;
  outline: none;
  transition: all 0.2s ease;
  border-radius: 3px;

  &:hover {
    background: ${cardisTheme.colors.backgroundGray};
    border-bottom-color: ${cardisTheme.colors.borderLight};
  }

  &:focus {
    background: ${cardisTheme.colors.backgroundGray};
    border-bottom-color: ${cardisTheme.colors.primary};
  }

  @media print {
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
  }
`

export const RemoveButton = styled.button`
  font-family: ${cardisTheme.fonts.body};
  font-size: ${cardisTheme.fontSizes.small};
  font-weight: ${cardisTheme.fontWeights.medium};
  color: ${cardisTheme.colors.danger};
  background: transparent;
  border: 1px solid ${cardisTheme.colors.danger};
  border-radius: 3px;
  padding: ${cardisTheme.spacing.tinyGap} ${cardisTheme.spacing.smallGap};
  cursor: pointer;
  transition: all 0.2s ease;
  align-self: flex-start;
  margin-top: ${cardisTheme.spacing.tinyGap};

  &:hover {
    background: ${cardisTheme.colors.danger};
    color: ${cardisTheme.colors.background};
  }

  @media print {
    display: none !important;
  }
`
